// Autogenerated file
export const tripSheetStatusesEnum = {
    New: "New",
    Issued: "Issued",
    Closed: "Closed",
    Cancelled: "Cancelled",
};
export const tripSheetStatuses = [
    { label: "Новый", value: "New" },
    { label: "Выдан", value: "Issued" },
    { label: "Закрыт", value: "Closed" },
    { label: "Отменен", value: "Cancelled" },
];
